<app-shipment-system-simplenav></app-shipment-system-simplenav>

<div class="map-system ms-3  me-3">
    <div style="flex: 0 0 300px; overflow-x: hidden; overflow-y: scroll;">
        <div class="me-3">
            <div class="mt-3">

                <ngb-alert [dismissible]="false" *ngIf="alert" [type]="alertType">
                    {{alert}}
                </ngb-alert>

                <p *ngIf="showMissingWarning">
                    <ngb-alert [type]="'warning'">
                    <a [routerLink]="['/shipping-missing-coordinates']" [queryParams]="{branch: options.branch.length > 0 ? options.branch.join(';') : null, startDate: this.options.startDate.format('YYYY-MM-DD'), endDate: this.options.endDate.format('YYYY-MM-DD')}">
                        Der er <strong>{{showMissingWarning}}</strong> manglende koordinater
                    </a>
                    </ngb-alert>
                </p>
                <p>
                <button *ngIf="alert" (click)="resetOptions()" class="btn  btn-sm  btn-warning">Nulstil søgning</button>
                </p>

                <div *ngIf="options.isSearching===false">
                            <div>
                                <h6 class="mt-4" i18n>Deliveries</h6>

                                <div class="row">
                                    <div class="col-12 form-group input text required">
                                        <label for="shipment-system-start-date" i18n>Leveringsdato fra</label>

                                        <app-date-time-picker [(date)]="options.startDate"
                                                              [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                                                              [inputSmall]="true"
                                                              (dateChange)="startDateChanged($event)"
                                                              id="shipment-system-start-date"
                                                              type="text"
                                                              name="calendarWeeks"></app-date-time-picker>
                                    </div>

                                    <div class="col-12 form-group input text required">
                                        <label for="shipment-system-end-date" i18n>Leveringsdato til</label>
                                        <app-date-time-picker [(date)]="options.endDate"
                                                              [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                                                              [inputSmall]="true"
                                                              (dateChange)="endDateChanged($event)"
                                                              id="shipment-system-end-date"
                                                              type="text"
                                                              name="calendarWeeks"></app-date-time-picker>
                                    </div>


                                    <div class="col-12">
                                        <div class="d-flex  justify-content-between">
                                            <button (click)="today()" class="btn  btn-sm  btn-primary  me-2" [disabled]="loadingShipments">I dag</button>
                                            <button (click)="tomorrow()" class="btn  btn-sm  btn-primary  me-2" [disabled]="loadingShipments">I morgen</button>
                                            <button (click)="thisWeek()" class="btn  btn-sm  btn-primary  me-2" [disabled]="loadingShipments">Denne uge</button>
                                            <button (click)="nextWeek()" class="btn  btn-sm  btn-primary" [disabled]="loadingShipments">Næste uge</button>
                                        </div>
                                    </div>

                                </div>

                                <hr>

                                <h6 class="mt-4">Distributører</h6>

                                <span *ngIf="showAllCarriers || options.showTenFourShipment">

                                <input type="checkbox" name="showTenFourShipment"
                                       [(ngModel)]="options.showTenFourShipment">
                                <span style="display: inline-block; width: 95px;"><img
                                    src="{{environment.assetBase}}/assets/img/10-4-logo.svg"
                                    style="height: 12px; margin: 8px 8px;"></span>
                                10-4 Levering
                                <br>
                                </span>

                                <span *ngIf="showAllCarriers || options.showPostNordShipment">

                                <input type="checkbox" name="showPostNordShipment"
                                       [(ngModel)]="options.showPostNordShipment">
                                <span style="display: inline-block; width: 95px;"><img
                                    src="{{environment.assetBase}}/assets/img/postnord-logo.png"
                                    style="height: 12px; margin: 8px 8px;"></span>
                                Post Nord
                                <br>
                                </span>

                                <span *ngIf="showAllCarriers || options.showGLSShipment">

                                <input type="checkbox" name="showGLSShipment" [(ngModel)]="options.showGLSShipment">
                                <span style="display: inline-block; width: 95px;"><img
                                    src="{{environment.assetBase}}/assets/img/gls-logo.png"
                                    style="height: 12px; margin: 8px 8px;"></span>
                                GLS
                                <br>
                                </span>
                                <span *ngIf="showAllCarriers || options.showDanskeFragtmaendShipment">

                                <input type="checkbox" name="showDanskeFragtmaendShipment"
                                       [(ngModel)]="options.showDanskeFragtmaendShipment">
                                <span style="display: inline-block; width: 95px;"><img
                                    src="{{environment.assetBase}}/assets/img/danske-fragtmaend-logo.png"
                                    style="height: 12px; margin: 8px 8px;"></span>
                                Danske Fragtmænd
                                <br>
                                </span>
                                <span *ngIf="showAllCarriers || options.showAfhenterShipment">

<input type="checkbox" name="showDanskeFragtmaendShipment"
                                       [(ngModel)]="options.showAfhenterShipment">
                                <span style="display: inline-block; width: 95px;"><img
                                    src="{{environment.assetBase}}/assets/img/10-4-logo.svg"
                                    style="height: 12px; margin: 8px 8px;"></span>
                                Afhenter
                                <br>

                                </span>

                                <span *ngIf="showAllCarriers || options.showBoxenShipment">

<input type="checkbox" name="showBoxenShipment"
       [(ngModel)]="options.showBoxenShipment">
                                <span style="display: inline-block; width: 95px;"><img
                                        src="{{environment.assetBase}}/assets/img/10-4-boxen.png"
                                        style="height: 12px; margin: 8px 8px;"></span>

                                    Boxen
                                <br>

                                </span>


                                <span *ngIf="showAllCarriers || options.showDropship">

<input type="checkbox" name="showDropship"
                                       [(ngModel)]="options.showDropship">
                                <span style="display: inline-block; width: 95px;"><img
                                    src="{{environment.assetBase}}/assets/img/dropship.png"
                                    style="height: 12px; margin: 8px 8px;"></span>
                                Direkte
                                <br>

                                </span>

                                <a (click)="showAllCarriers = !showAllCarriers"
                                   class="btn  btn-sm  btn-link  mb-3">{{ showAllCarriers?'Skjul distributører' : 'Vis distributører' }}</a>



                                <hr>
                                <label class="form-label" for="preset">Ordre filter:</label>
                                <select class="form-control" id="preset"
                                        required
                                        name="preset"
                                        [(ngModel)]="options.statusFilter">
                                    <option [ngValue]="null">Alle</option>
                                    <option *ngFor="let filterPreset of filterPresets" [ngValue]="filterPreset.key" >{{filterPreset.name}}</option>
                                </select>

<!-- @hint see https://git.hassel-it.dk/10-4/10-4-admin/-/issues/524
<!--                                <div class="d-flex justify-content-between align-items-baseline mb-2">-->
<!--                                    <label i18n>Assignment</label>-->
<!--                                    <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic"-->
<!--                                         [(ngModel)]="options.assignmentStatus">-->
<!--                                        <label ngbButtonLabel class="btn-outline-primary">-->
<!--                                            <input ngbButton type="radio" [value]="'all'">-->
<!--                                            <ng-container i18n>All</ng-container>-->
<!--                                        </label>-->
<!--                                        <label ngbButtonLabel class="btn-outline-success">-->
<!--                                            <input ngbButton type="radio" [value]="'assigned'">-->
<!--                                            <ng-container i18n>Assinged</ng-container>-->
<!--                                        </label>-->
<!--                                        <label ngbButtonLabel class="btn-outline-danger">-->
<!--                                            <input ngbButton type="radio" [value]="'not-assiged'">-->
<!--                                            <ng-container i18n>Pending</ng-container>-->
<!--                                        </label>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--
                                <div class="d-flex justify-content-between align-items-baseline mb-2">
                                    <label i18n>Delivered</label>
                                    <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic"
                                         [(ngModel)]="options.deliveryStatus">
                                        <label ngbButtonLabel class="btn-outline-primary">
                                            <input ngbButton type="radio" [value]="'all'">
                                            <ng-container i18n>All</ng-container>
                                        </label>
                                        <label ngbButtonLabel class="btn-outline-success">
                                            <input ngbButton type="radio" [value]="'deliverd'">
                                            <ng-container i18n>Delivered</ng-container>
                                        </label>
                                        <label ngbButtonLabel class="btn-outline-danger">
                                            <input ngbButton type="radio" [value]="'not-deliverd'">
                                            <ng-container i18n>Pending</ng-container>
                                        </label>
                                    </div>
                                </div>
-->

                                <hr>

                                <p *ngIf="!shipmentRoutes" class="text-muted" i18n>Indlæser ...</p>

                                <div class="row">

                                    <div class="col-12  text-end">

                                        <div class="d-flex  justify-content-between">
                                            <!-- @hint see https://git.hassel-it.dk/10-4/10-4-admin/-/issues/524
                            <button (click)="resetOptions()" class="btn  btn-sm  btn-warning">Nulstil
                                 søgning
                             </button>-->

                             <button (click)="dateSearch()" class="btn  btn-sm  btn-success"
                                     [disabled]="loadingShipments">
                                 <i class="fas fa-search"></i>&nbsp;<span i18n>Search</span>
                             </button>
                         </div>
                     </div>

                     <div class="col-12">
                         <div class="mt-1 mb-1" style="height: 0.625rem">
                             <ngb-progressbar *ngIf="loadingShipments" type="warning" [value]="100"
                                              [striped]="true" [animated]="true">Søger...
                             </ngb-progressbar>
                         </div>
                     </div>
                 </div>

                 <div *ngIf="shipmentRoutes">

                     <div class="d-flex justify-content-between">

                     <button (click)="resetBranchDrivers()" class="btn  btn-sm  btn-primary  mb-3"
                             [disabled]="!showResetBranchDriversButton()">Nulstil chauffør/afdeling
                         filter
                     </button>
                     <!-- *ngIf="isOneDay() -->
                                    <button  (click)="showAllRoutes()"
                                             class="btn  btn-sm  btn-primary  mb-3">{{ showingAllRoutes ? 'Skjul alle ruter' : 'Vis alle ruter' }}
                                    </button>
                                    </div>

                     <ng-template ngFor let-branch [ngForOf]="drivers">
                                        <div class="card  mb-2" *ngIf="branch.show || showAllBranches">
                                            <div class="card-body  pt-2  ps-2  pb-2  pe-2">
                                                <h5>
                                                    <span [ngStyle]="{'background-color': shipmentsService.colorForBranch(branch.branch)}">&nbsp;&nbsp;</span>

                                                    <input type="checkbox" name="" [(ngModel)]="branch.show"
                                                           style="margin-left: 5px; vertical-align: 1px;"
                                                           (ngModelChange)="driversChanged()">

                                                    {{ getBranchName(branch.branch) }}
                                                    <a href="javascript:" (click)="showTable(branch.branch, null)"
                                                       class="fllloat-right">
                                                        <i class="fas  fa-arrow-circle-right  text-info"></i>
                                                    </a>
                                                </h5>
                                               <!-- <ng-template ngFor let-driver [ngForOf]="branch.drivers">
                                                    {{ driver.name }}
                                                </ng-template> -->

                                                    <!--                                                    <input type="checkbox" name="drivers-{{ branch.branch }}-{{ driver.driver }}"-->
                                                    <!--                                                           [(ngModel)]="driver.show" style="vertical-align: 1px;"> -->

<!--                                    <a href="javascript:" (click)="showTable(branch.branch , driver)">-->
                                                        <!--                                        <i class="fas  fa-arrow-circle-right  text-info"></i>-->
                                                        <!--                                    </a>-->
                                            </div>
                                        </div>
                                    </ng-template>
                    <a (click)="showAllBranches = !showAllBranches"
                       class="btn  btn-sm  btn-link  mb-3">{{ showAllBranches?'Hide branches' : 'Show branches' }}</a>

                                </div>

                                <a *ngIf="showmap" href="javascript:" (click)="showTable(null, null)" i18n>Show
                                    table</a>
                            </div>


                </div>

                    <div *ngIf="options.isSearching ===true">
                        <h6 class="mt-4" i18n>Search</h6>

                            <form (ngSubmit)="search()" novalidate>
                                <div class="mt-3">
                                    <div class="row mb-3">
                                        <div class="col-12">
                                            <label for="search_return" i18n>
                                            <input type="checkbox" name="search_return" [(ngModel)]="searchOptions.search_return" >
                                                Search returns
                                            </label>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Order ref</label>

                                                <input type="text" class="form-control" name="order_reference"
                                                       [(ngModel)]="searchOptions.order_reference">
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Nota number</label>

                                                <input type="text" class="form-control" name="nota_number"
                                                       [(ngModel)]="searchOptions.nota_number">
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group input text">
                                                <label for="purchase_order" i18n>Indkøbsordre</label>

                                                <input type="text" class="form-control" name="purchase_order" id="purchase_order"
                                                       [(ngModel)]="searchOptions.purchase_order">
                                            </div>
                                        </div>

                                        <div class="col-md-6">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Product number</label>

                                                <input type="text" class="form-control" name="product_number"
                                                       [(ngModel)]="searchOptions.product_number">
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Navn</label>

                                                <input type="text" class="form-control" name="contact_information_name"
                                                       [(ngModel)]="searchOptions.contact_information_name">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Adresse</label>

                                                <input type="text" class="form-control" name="contact_information_adress"
                                                       [(ngModel)]="searchOptions.contact_information_adress">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Email</label>

                                                <input type="text" class="form-control" name="contact_information_email"
                                                       [(ngModel)]="searchOptions.contact_information_email">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Mobil</label>

                                                <input type="text" class="form-control" name="contact_information_phone"
                                                       [(ngModel)]="searchOptions.contact_information_phone">
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group input text">
                                                <label for="time" i18n>Tracking</label>

                                                <input type="text" class="form-control" name="tracking_number"
                                                       [(ngModel)]="searchOptions.tracking_number">
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" class="btn  btn-primary"
                                            [disabled]="loadingShipments || !shouldShowReset()" i18n>Search</button>
                                    <button *ngIf="shouldShowReset()" (click)="resetSearch()" class="btn  btn-defalut"
                                            i18n>Reset</button>
                                </div>
                            </form>

                    </div>
            </div>
        </div>
    </div>

    <div style="flex-grow:1">

        <div class="d-flex flex-row justify-content-between">
            <div>
                <button class="btn  btn-sm  btn-primary m-2" (click)="showMap()">{{showmap ? 'Skjul' : 'Vis'}} kort</button>
                <button class="btn  btn-sm  btn-primary m-2" (click)="toggleshowStockStatus()">Vis lagerstatus</button>
            </div>

            <div class="align-self-center p-2" *ngIf="options.branch.length === 1">
                <form class="form-inline d-flex flex-row align-items-center">

                    <div class="form-check me-1">
                        <input class="form-check-input" type="checkbox"
                               id="inlineFormCheck"
                               [(ngModel)]="shipmentsService.paintData.active" [ngModelOptions]="{standalone: true}">
                        <label class="form-check-label" for="inlineFormCheck">
                            Paint
                        </label>
                    </div>

                    <select class="custom-select custom-select-sm me-1"
                            [(ngModel)]="shipmentsService.paintData.shipmentRoute"
                            [ngClass]="{
                            'is-valid' : shipmentsService.paintData.shipmentRoute && shipmentsService.paintData.shipmentRoute.id,
                            'is-invalid': !shipmentsService.paintData.shipmentRoute || shipmentsService.paintData.shipmentRoute === null,
                            'opacity-25': shipmentsService.paintData.active === false}"
                            name="shipment-route-id"
                    >
                        <option i18n [ngValue]="null">Pick driver</option>
                        <ng-template ngFor let-shipmentRoute [ngForOf]="shipmentRoutes">
                            <option [ngValue]="shipmentRoute" *ngIf="shipmentRoute.branch === options.branch[0]">{{ shipmentRoute.name }} {{ shipmentRoute.trip }}
                                ({{ shipmentRoute.branch }})
                            </option>
                        </ng-template>
                    </select>

                    <div style="position:relative;" [ngClass]="{
                    'opacity-25': shipmentsService.paintData.active === false}">
                        <app-date-time-picker [(date)]="shipmentsService.paintData.shipping_date"
                                              [options]="{clearcalendarWeeks:true, format: 'DD-MM-YYYY'}"
                                              [inputSmall]="true"
                                              [invalid]="!shipmentsService.paintData.shipping_date ||!shipmentsService.paintData.shipping_date.isValid()"
                                              [valid]="shipmentsService.paintData.shipping_date && shipmentsService.paintData.shipping_date.isValid()"
                                              id="shipment-shipping-date"
                                              type="text"
                                              name="shipment-shipping-date"></app-date-time-picker>
                    </div>
                </form>
            </div>
        </div>

        <ng-container *ngIf="!showmap">
            <p *ngIf="!shipments" class="text-muted  p-3">Indlæser ...</p>

            <div *ngIf="shipments && shipmentRoutes" class="p-3" [ngClass]="{ 'opacity-25': loadingShipments }">
                <app-shipping-system-sorter [shipments]="shipments"
                                            [options]="options"
                                            [shipmentRoutes]="shipmentRoutes"
                                            [branch]="options.branch"
                                            [driver]="options.driver"
                                            [oneDay]="!showStockStatus && !isSearching && !options.isSearching && isOneDay()"
                                            [expandOrderLines]="expandOrderLines"
                                            (shipmentsChanged)="reloadShipments()"
                                            (routeChanged)="routeChanged($event)"></app-shipping-system-sorter>
            </div>
        </ng-container>

        <button *ngIf="isShowingRoute()" (click)="hideRoute()" class="btn  btn-sm  btn-primary  my-2  float-right">
            Skjul route<span *ngIf="routes.length > 1">r</span>
        </button>
<!-- mapbox://styles/partnerit/cm69vdzoo002301r23nrl7ucg -->
<!-- mapbox://styles/partnerit/ck3zsiap202rj1cqztkdn7s5s/draft -->
        <div class="map-wrapper" style="position: relative" [ngClass]="{ 'opacity-25': loadingShipments }" *ngIf="showmap" #mapWrapper>
            <app-map
                    (rightClicked)="performPaint($event)"
                    [routes]="routes" [pointsCollection]="pointsCollection" [drivers]="driverPoints" [branches]="branchPoints"></app-map>
            <!--            <a href="javascript:" (click)="print()">print</a>-->
            <!--            <img id="img" src="" #outputImage>-->
        </div>
    </div>
    <div style="width: 400px;overflow-x: hidden;overflow-y: scroll;"
         *ngIf="selectedPoint && selectedPoint.properties && showmap">
        <div class="p-3">
            <a href="javascript:" class="btn btn-primary" (click)="closeDetail()">Luk</a>
            <app-shipment-details-popup [shipmentId]="selectedPoint?.properties?.id" [lastUpdate]="this.lastUpdate"></app-shipment-details-popup>
        </div>
    </div>
    <div style="width: 400px;overflow-x: hidden;overflow-y: scroll;" *ngIf="isShowingRoute() && showmap && routeShipments && routeShipments.length > 0">
        <div class="px-3">
            <button (click)="showRouteEstimates = !showRouteEstimates" class="btn  btn-sm  btn-primary  mt-2  mb-2">Vis estimater</button>

            <ul class="mt-3  p-0" style="list-style: none">
                <ng-template ngFor let-routeShipment [ngForOf]="routeShipments" let-i="index">
                    <li class="ps-3" style="border-left: 3px solid #acacac; margin-bottom: -16px;">
                        <div style="margin: 0 0 -16px -22px; width: 9px; height: 9px; border-radius: 50%; background: #acacac; border: 1px solid #dedede;"></div>
                        <app-shipment-status-widget [status]="routeShipment.shipment_status" [label]="routeShipment.formattedStatus()"></app-shipment-status-widget>
                        <img *ngIf="i !== 0 && i !== routeShipments.length - 1"
                                style="height: 20px; width: auto"
                                src="{{shipmentsService.iconSlugForRoute(routeShipment, i - 1).iconImage}}">

                        <span *ngIf="routeShipment.order_reference" class="badge  text-bg-secondary" style="vertical-align: 1px;">web</span> {{ routeShipment.order_reference }}
                        <span *ngIf="routeShipment.nota_number" class="badge  text-bg-secondary" style="vertical-align: 1px;">nota</span> {{ routeShipment.nota_number }}

                        <br>

                        Address: <b>{{ routeShipment?.shipment_address?.adress_1_receiver }}</b><br>

                        <div *ngIf="routeShipment.estimated_delivery && routeShipment.shipment_status !== 'complete'" class="mt-2">
                            <i class="fa fa-clock"></i> Forventet: <b>{{routeShipment.estimated_delivery.format('DD-MM-YYYY HH:mm')}}</b><br/>
                            <i class="fa fa-cog"></i> Aflæsning: <b>{{routeShipment.dropoff_time}}</b> minutter
                        </div>

                        <div *ngIf="routeShipment.shipment_status === 'complete'" class="mt-2">
                            <i class="fa fa-check"></i> Leveret<ng-container *ngIf="routeShipment.actual_delivery"> : <b>{{routeShipment.actual_delivery.format('DD-MM-YYYY HH:mm') }}</b></ng-container><br/>
                            <i class="fa fa-cog"></i> Aflæsning: <b>{{routeShipment.dropoff_time}}</b> minutter
                        </div>

                        <div *ngIf="showRouteEstimates && i != 0" class="mt-2">
                            Estimat: <b>{{ parseRouteDurationForIndex(i) }}</b> <span class="text-muted  me-1  ms-1">|</span> <b>{{ parseRouteDistanceForIndex(i) }}</b>
                        </div>

                        <div class="pb-4">&nbsp;</div>
                    </li>
                </ng-template>
            </ul>
        </div>
    </div>
</div>
